import React, { useState, useEffect } from "react";
import {
  Input,
  Select,
  Col,
  Row,
  notification,
  Form,
  Button,
  Switch,
} from "antd";
import { useMediaQuery } from "react-responsive";
import { PlusOutlined } from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";

const { Option } = Select;
const tailLayout = {
  wrapperCol: {
    offset: 15,
    span: 5,
  },
};
const layout = {
  labelCol: {
    span: 14,
  },
  wrapperCol: {
    span: 10,
  },
};

const FirmClassUpdate = (props) => {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });
  const [loading, setLoading] = useState(false);
  const [firmClassId, setfirmClassId] = useState(props.firmClassId);
  const [Name, setName] = useState(props.name);
  const [serialNumber, setSerialNumber] = useState(props.serialNumber);
  const [erpValue, setErpValue] = useState(props.erpValue);
  const [FirmTypeValue, setFirmTypeValue] = useState(props.firmTypeValue);
  const [isErpType, setIsErpType] = useState(props.isErpType);
  const [firmTypeDropdown, setfirmTypeDropdown] = useState([]);

  useEffect(() => {
    RequestHandler.get(`/Firm/GetFirmType`).then((response) => {
      setfirmTypeDropdown(response.data);
    });

    setfirmClassId(props.firmClassId);
    setName(props.name);
    setSerialNumber(props.serialNumber);
    setErpValue(props.erpValue);
    setFirmTypeValue(props.firmTypeValue);
    setIsErpType(props.isErpType);
  }, [
    setfirmTypeDropdown,
    setfirmClassId,
    setFirmTypeValue,
    setName,
    setSerialNumber,
    setErpValue,
    setIsErpType,
    props.serialNumber,
    props.erpValue,
    props.name,
    props.firmTypeValue,
    props.firmTypeDropdown,
    props.firmClassId,
    props.isErpType,
  ]);

  const onChange = (e) => {
    setName(e.target.value);
  };
  const onChangeSerialNumber = (e) => {
    setSerialNumber(e.target.value);
  };
  const onChangeErpValue = (e) => {
    setErpValue(e.target.value);
  };
  const onChangeFirmValue = (e) => {
    setFirmTypeValue(e);
  };

  const onChangeErpType = (e) => {
    setIsErpType(e);
  };
  const onFinishUpdate = (values) => {
    RequestHandler.put(
      `/FirmClass`,
      {
        id: firmClassId,
        name: values.Name,
        serialNumber: values.SerialNumber,
        erpValue: values.ErpValue,
        firmTypeValue: values.FirmTypeValue,
        isErpType: isErpType,
      },
      false,
      { rawResponse: true }
    ).then((res) => {
      if (res.status === 200) {
        openNotificationWithIconUpdate("success");
        setTimeout(
          function () {
            props.sendDataForUpdate("success");
            setLoading(false);
          }.bind(this),
          2000
        );
      }else{
        setLoading(false)
        }
    }).catch(function (error) {
      setLoading(false);
    });
  };

  const onFinishFailedUpdate = () => setLoading(false);

  const openNotificationWithIconUpdate = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Güncelleme işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };

  return (
    <div>
      <Form
        {...layout}
        name="basic"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinishUpdate}
        onFinishFailed={onFinishFailedUpdate}
        fields={[
          { name: "Name", value: Name },
          { name: "ErpValue", value: erpValue },
          { name: "SerialNumber", value: serialNumber },
          { name: "FirmTypeValue", value: FirmTypeValue.toString() },
          { name: "IsErpType", value: isErpType },
        ]}
      >
        <Row>
          {isDesktopOrLaptop && (
            <>
              <Col span={18}>
                <Form.Item
                  label="Cari Sınıfı Adı"
                  style={{ marginTop: "4%" }}
                  name="Name"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Cari Adı/Ünvanı alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Input value={Name} onChange={onChange} />
                </Form.Item>
                <Form.Item
                  label="Cari Tipi"
                  name="FirmTypeValue"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Cari Tipi alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Select
                    placeholder="Seçiniz"
                    onChange={onChangeFirmValue}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                  >
                    {firmTypeDropdown.map((item) => (
                      <Option key={item.key}>{item.value}</Option>
                    ))}
                  </Select>
                </Form.Item>
     
                {/* <Form.Item
                  label="Erp Kod"
                  name="ErpValue"
                  style={{ marginTop: "4%" }}
                >
                  <Input
                    maxLength={100}
                    value={erpValue}
                    onChange={onChangeErpValue}
                  />
                </Form.Item>
                <Form.Item
                  label="Erp Aktarım'da kullanılsın mı?"
                  name="IsErpType"
                  valuePropName="checked"
                >
                  <Switch value={isErpType} onChange={onChangeErpType} />
                </Form.Item> */}
              </Col>
              <Col span={6}></Col>
              <Col span={6}></Col>
              <Col span={9}></Col>
              <Col span={7}>
                <Form.Item {...tailLayout}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    htmlType="submit"
                    onClick={() => setLoading(true)}
                    loading={loading}
                  >
                    Güncelle
                  </Button>
                </Form.Item>
              </Col>
              <Col span={2}></Col>
            </>
          )}
          {isTabletOrMobileDevice && (
            <>
              <Col span={24}>
                <Form.Item
                  label="Cari Sınıfı Adı"
                  style={{ marginTop: "4%" }}
                  name="Name"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Cari Adı/Ünvanı alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Input value={Name} onChange={onChange} />
                </Form.Item>
                <Form.Item
                  label="Cari Tipi"
                  name="FirmTypeValue"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Cari Tipi alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Select
                    placeholder="Seçiniz"
                    onChange={onChangeFirmValue}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                  >
                    {firmTypeDropdown.map((item) => (
                      <Option key={item.key}>{item.value}</Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Seri No"
                  name="SerialNumber"
                  style={{ marginTop: "4%" }}
                >
                  <Input
                    maxLength={20}
                    value={serialNumber}
                    onChange={onChangeSerialNumber}
                  />
                </Form.Item>
                <Form.Item
                  label="Erp Kod"
                  name="ErpValue"
                  style={{ marginTop: "4%" }}
                >
                  <Input
                    maxLength={100}
                    value={erpValue}
                    onChange={onChangeErpValue}
                  />
                </Form.Item>

                <Form.Item
                  label="Erp Aktarım'da kullanılsın mı?"
                  name="IsErpType"
                  valuePropName="checked"
                >
                  <Switch value={isErpType} onChange={onChangeErpType} />
                </Form.Item>
              </Col>
              <Col span={10}></Col>
              <Col span={8}>
                <Form.Item {...tailLayout}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    htmlType="submit"
                    onClick={() => setLoading(true)}
                    loading={loading}
                  >
                    Güncelle
                  </Button>
                </Form.Item>
              </Col>
              <Col span={6}></Col>
            </>
          )}
        </Row>
      </Form>
    </div>
  );
};
export default FirmClassUpdate;
